import React from 'react';
import { useCallback } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
const useDynamicListEvent = () => {
  const [refElement, setRefElement] = useState();
  const changeEffectDraggable = useCallback((event, evt) => {
    evt !== 'dragstart' && event.preventDefault();
    if (evt == 'dragover' || evt == 'drop') {
      event.preventDefault();
      event.stopPropagation();
    }
    if (typeof event.dataTransfer !== 'undefined') {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.dropEffect = 'move';
    }
  });
  useEffect(() => {
    if (refElement?.current) {
      const items = refElement.current.querySelectorAll(':scope > div');
      ['dragenter', 'dragend', 'dragstart', 'dragover', 'drop'].forEach(
        (evt) => {
          items.forEach((element) =>
            element.addEventListener(
              evt,
              (event) => {
                changeEffectDraggable(event, evt);
              },
              false
            )
          );
        }
      );
    }
  }, [refElement?.current]);
  return { setRefElement };
};

export default useDynamicListEvent;
